import { connect } from "react-redux";
import Supervisor from './supervisor'
import { bindActionCreators } from "redux";
import { createSupervisor } from "services/redux/Valet/Supervisor/action";

const mapStateToProps = (state) => ({
    supervisorRes : state.CreateSupervisor.supervisorRes
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        createSupervisor,
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Supervisor);